import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';
import { AxiosError } from 'axios';

import {
  fetchAssetSocialActions,
  rateAssetActions,
  exchangeSocialTokenActions,
  fetchListUserSocialActions,
} from '@/redux/actions/service-directory/social';
import { SocialInstance } from '@/services/service-directory/social';

export function* rateAssetSaga(action: ActionType<typeof rateAssetActions.request>) {
  try {
    const { formAsset, socialUserToken } = action.payload;
    yield call(SocialInstance.rateAsset, formAsset, socialUserToken);
    yield put(rateAssetActions.success());
  } catch (err) {
    yield put(rateAssetActions.failure(err));
  }
}

export function* fetchAssetSocialSaga(action: ActionType<typeof fetchAssetSocialActions.request>) {
  try {
    const { socialUserToken } = action.payload;
    const response = yield call(SocialInstance.fetchAssetSocial, socialUserToken);
    yield put(fetchAssetSocialActions.success(response));
  } catch (err) {
    yield put(fetchAssetSocialActions.failure(err));
  }
}

export function* exchangeSocialTokenSaga(action: ActionType<typeof exchangeSocialTokenActions.request>) {
  try {
    const { socialToken, socialNetwork, email, fullName } = action.payload;
    yield call(SocialInstance.exchangeSocialToken, socialToken, socialNetwork, email, fullName);
    yield put(exchangeSocialTokenActions.success());
  } catch (err) {
    yield put(exchangeSocialTokenActions.failure(err));
  }
}

export function* fetchListUserSocialSaga(action: ActionType<typeof fetchListUserSocialActions.request>) {
  const { pageNum, pageSize, searchText, sort } = action.payload;
  try {
    const { data, paging } = yield call(SocialInstance.fetchListUserSocial, pageNum, pageSize, sort, searchText);
    yield put(fetchListUserSocialActions.success({ data, paging }));
  } catch (err) {
    const errorResponse = (err as AxiosError)?.response;
    const errors = {
      status: errorResponse?.status,
      message:
        errorResponse?.data?.message ||
        errorResponse?.data?.error_description ||
        errorResponse?.data?.errors?.[0].message ||
        err.message,
    };
    yield put(fetchListUserSocialActions.failure(errors));
  }
}

export default function* root() {
  yield all([takeLatest(rateAssetActions.request.type, rateAssetSaga)]);
  yield all([takeLatest(fetchAssetSocialActions.request.type, fetchAssetSocialSaga)]);
  yield all([takeLatest(exchangeSocialTokenActions.request.type, exchangeSocialTokenSaga)]);
  yield all([takeLatest(fetchListUserSocialActions.request.type, fetchListUserSocialSaga)]);
}
